import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useSentinelTheme } from "../contexts/ThemeContext";

const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [22, 36],
  iconAnchor: [11, 36],
});

function ClickCapture({ onClick }) {
  useMapEvents({
    click(e) {
      onClick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

export function PointPickerMap({ lat, lon, onPick, center = [41.451, 2.176], height = "260px" }) {
  const { salaControl } = useSentinelTheme();
  const tileUrl = salaControl
    ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
    : "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";

  return (
    <div style={{ height }} className="w-full overflow-hidden rounded-lg border border-border relative z-0" data-testid="point-picker-map">
      <MapContainer center={lat && lon ? [lat, lon] : center} zoom={14} style={{ height: "100%", width: "100%" }}>
        <TileLayer url={tileUrl} attribution="&copy; OpenStreetMap &copy; CartoDB" />
        <ClickCapture onClick={onPick} />
        {lat && lon && <Marker position={[lat, lon]} icon={markerIcon} />}
      </MapContainer>
    </div>
  );
}
